import { Box, Card, CardContent, Typography } from '@mui/material';
import { FaHandHoldingHeart, FaDollarSign, FaUsers, FaTrophy } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import COLORS from '../../../../../../constants/colors';

const achievements = [
  { title: 'Total Fundraisers', value: 10, icon: <FaHandHoldingHeart size={35} color={COLORS.white} /> },
  { title: 'Total Donations', value: 30, icon: <FaDollarSign size={35} color={COLORS.white} /> },
  { title: 'Active Donors', value: 60, icon: <FaUsers size={35} color={COLORS.white} /> },
  { title: 'Successful Campaigns', value: 6, icon: <FaTrophy size={35} color={COLORS.white} /> }
];

const CountUp = ({ end }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        start = end;
        clearInterval(timer);
      }
      setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [end]);

  return <>{count.toLocaleString()}</>;
};

const AchievementCards = () => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' },
        gap: 4,
        width: '100%',
        maxWidth: 1200,
        py: 8,
        px: 3,
        margin: '0 auto',
      }}
    >
      {achievements.map((achievement, index) => (
        <Card
          key={index}
          sx={{
            backgroundColor: `${COLORS.white}`,
            borderRadius: 4,
            boxShadow: `0 6px 25px ${COLORS.primary}15`,
              border: `1px solid ${COLORS.accent}`, // New: Border on hover
            
          }}
        >
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 2,
                width: 70, // Slightly larger
                height: 70, // Slightly larger
                borderRadius: '50%',
                background: COLORS.primary, // New: Gradient background
                margin: '0 auto',
                mb:1
              }}
            >
              {achievement.icon}
            </Box>
            <Typography
              variant="h5" // Changed to h4 for more prominence
              fontWeight={800} // Bolder font weight
              color={COLORS.primary}
              sx={{ mb: 1,mt:1, letterSpacing: '0.03em' }} // Added letter spacing
            >
              <CountUp end={achievement.value} />+
            </Typography>
            <Typography variant="body1" color={COLORS.secondary}> {/* You could define a COLORS.textSecondary for a darker grey here */}
              {achievement.title}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default AchievementCards;